var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeroBar',{attrs:{"has-right-visible":false}},[_vm._v("\n    Legal\n  ")]),_c('section',{staticClass:"section is-main-section"},[_c('CardComponent')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }